<template>
  <v-dialog :value="value" width="450" persistent>
    <v-card>
      <v-card-title class="mb-2">Move number to another product</v-card-title>

      <v-card-subtitle class="mb-2">This will move the number to another VoIP product</v-card-subtitle>

      <v-card-text>
        <v-text-field v-model="product" label="VoIP product search" outlined hide-details :loading="getSearchProductsLoading" class="mb-4" >
          <template #append>
            <v-icon color="primary" :disabled="disableSearch" @click="search">{{ mdiMagnify }}</v-icon>
          </template>
        </v-text-field>
        
        <template v-if="showSearchResults">
          <v-radio-group v-model="product_id" hide-details>
            <template v-for="(product, index) in getProducts">
              <template v-if="index<=2">
                <v-radio :key="product.reference" :label="`${product.reference} - ${product.business}`" :value="product.reference" class="mb-4"></v-radio>
              </template>
            </template>
          </v-radio-group>

          <div class="mb-3">Please provide information about why this number is being moved. This will help us improve the system in the future.</div>

          <v-textarea v-model="reason_note" label="Reason" placeholder="Type here..." outlined hide-details="auto" :error-messages="reasonNoteErrors" @input="$v.reason_note.$touch()" @blur="$v.reason_note.$touch()"></v-textarea>
        </template>

        <template v-if="showNoResults">
           <div>0 Results found</div>
        </template>
      </v-card-text>

      <v-divider class="mt-2"></v-divider>

      <v-card-actions class="d-flex justify-end align-center">
        <v-btn color="primary" :loading="getMoveNumberToAnotherProductLoading" :disabled="disableOk" @click="submit">Ok</v-btn>
        <v-btn color="primary" outlined :disabled="disableClose" @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex';
  import { mdiMagnify } from '@mdi/js';
  import { validationMixin } from 'vuelidate';
  import { minLength  } from 'vuelidate/lib/validators';
  
  export default {
    mixins: [validationMixin],

    validations: {
      reason_note: { minLength: minLength(120) }
    },

    props: {
      value:{
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        mdiMagnify,
        product: '',
        product_id: '',
        reason_note: '',
        searchCompleted: false,
      }
    },

    computed: {
      ...mapGetters('productGeneral', ['getProducts', 'getSearchProductsLoading', 'getIsProducts']),
      ...mapGetters('numbers', ['getNumberId', 'getMoveNumberToAnotherProductLoading', 'getMoveNumberToAnotherProductError']),
      ...mapGetters('products', ['getCurrentProduct', 'getIsProductNumbersDeletionInProgress', 'getFetchProductNumbersLoading']),

      disableSearch() {
        return !this.product || this.getSearchProductsLoading || this.getMoveNumberToAnotherProductLoading || this.getFetchProductNumbersLoading;
      },

      disableOk() {
        return !this.product_id || !this.reason_note || this.$v.reason_note.$invalid || this.getMoveNumberToAnotherProductLoading || this.getFetchProductNumbersLoading;
      },

      disableClose() {
        return this.getSearchProductsLoading || this.getMoveNumberToAnotherProductLoading || this.getFetchProductNumbersLoading;
      },

      showSearchResults() {
        return this.searchCompleted && this.getIsProducts && !this.getSearchProductsLoading;
      },

      showNoResults() {
        return this.searchCompleted && !this.getIsProducts && !this.getSearchProductsLoading;
      },

      reasonNoteErrors() {
        const errors = [];

        if (!this.$v.reason_note.$dirty) return errors;
        !this.$v.reason_note.minLength && errors.push('You must enter at least 120 characters for the reason.');
        return errors;
      }
    },

    methods: {
      ...mapMutations('numbers', ['RESET_NUMBER_ID', 'UPDATE_IS_DELETE_NUMBER_POLLING']),
      ...mapActions('productGeneral', ['searchProducts']),
      ...mapActions('numbers', ['moveNumberToAnotherProduct']),
      ...mapActions('products', ['fetchProductNumbers']),

      async search() {
        this.searchedCompleted = false;
        this.product_id = '';
        await this.searchProducts(this.product);
        this.searchCompleted = true;
      },

      async submit() {
        await this.moveNumberToAnotherProduct({number_id: this.getNumberId, payload: {product_id: this.product_id, reason_note: this.reason_note}});

        if (!this.getMoveNumberToAnotherProductError) {
          await this.fetchProductNumbers(this.getCurrentProduct.id);
          if (this.getIsProductNumbersDeletionInProgress) {
            this.UPDATE_IS_DELETE_NUMBER_POLLING(true);
          } 
          this.close();
        }
      },

      reset() {
        this.product = '';
        this.product_id = '';
        this.reason_note = '';
        this.searchCompleted = false;
        this.RESET_NUMBER_ID();
        this.$v.$reset();
      },

      close() {
        this.reset();
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>